import type { Asset } from '@storyblok-types';

export const MEDIA_API_ENDPOINT = `/media/`;

export type AssetMetaData = {
  Artist?: string;
};

export function getAssetMetaData(asset: Asset): AssetMetaData {
  return (asset.meta_data ?? {}) as AssetMetaData;
}
